<template>
  <div class="container">
    <div class="d-flex card mb-2" v-if="errorMessage !== null">
      <div class="card-body">
        {{ errorMessage }}
      </div>
    </div>
    <div v-if="isLoaded" class="d-flex card">
      <div class="card-body">
        <!-- submitter information -->
        <div class="d-flex">
          <div class="flex-fill mr-1">
            <b-form-group label="Submitter Name" label-for="submitter-name">
              <b-form-input id="submitter-name" v-model="job.submitter_name"></b-form-input>
            </b-form-group>
          </div>
          <div class="flex-fill mr-1">
            <b-form-group label="Submitter Email" label-for="submitter-email">
              <b-form-input id="submitter-email" v-model="job.submitter_email"></b-form-input>
            </b-form-group>
          </div>
          <div class="d-flex align-items-center justify-content-center m-2" v-if="job.is_approved === 1 && job.hiring_organization !== null">
            <a class="btn btn-sm btn-primary" :href="tweetLink" target="_blank"><i class="fab fa-twitter"></i> Tweet It</a>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <b-form-group label="Job Title" label-for="job-title">
              <b-form-input id="job-title" v-model="job.job_title"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group label="Hiring Organization">
              <!--<organization-selector v-bind:organizationID="job.hiring_organization" v-on:selectedOrganization="(e) => { selectedOrganization(e) }"></organization-selector>-->
              <organization-selector-v2 v-bind:organizationID="job.hiring_organization" v-on:selectedOrganization="(e) => { selectedOrganization(e) }"></organization-selector-v2>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <b-form-group label="City" label-for="city">
              <b-form-input id="city" v-model="job.city"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-4">
            <b-form-group label="State" label-for="state">
              <b-form-input id="state" v-model="job.state"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-4">
            <b-form-group label="Country" label-for="country">
              <b-form-input id="country" v-model="job.country"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-form-group label="Job Description" label-for="job-description">
              <editor v-model="job.job_description" api-key="jqw6z4vn0w8in75osi6grc36roa1c8w0fd5bztyoldeqwf4v"
                      :init="{
                  plugins: 'wordcount lists',
                  menubar: false,
                  toolbar: 'undo redo | bold italic underline strikethrough | numlist bullist | alignleft aligncenter alignright alignjustify | outdent indent | fontselect',
                  fontformats: 'Arial = arial',
                  toolbar_sticky: true
              }"></editor>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <b-form-group label="Industry Type">
              <b-form-select v-model="job.industry" :options="industry"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-sm-4">
            <b-form-group label="Employment Type">
              <b-form-select v-model="job.employment_type" :options="employmentType"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-sm-4">
            <occupation-search v-bind:occupationID="job.occupational_category" v-on:selectedOccupation="(e) => { selectedOccupation(e) }"></occupation-search>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <b-form-group label="Date Posted" label-for="job-start-date">
              <b-form-input id="job-start-date" type="date" v-model="job.date_posted"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-4">
            <b-form-group label="Valid Through" label-for="job-end-date">
              <b-form-input id="job-end-date" type="date" v-model="job.valid_through"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-sm-10">
            <b-form-group label="Application URL" label-for="job-link">
              <b-form-input id="job-link" v-model="job.application_url"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-2">
            <b-form-group v-if="$store.getters.hasCapabilities('job_approval')" label="Approval Status" label-for="approval-status">
              <b-form-select id="approval-status" v-model="job.is_approved" :options="approvalStatus"></b-form-select>
            </b-form-group>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-sm-4">
            <b-form-group label="Featured Start" label-for="featured-start-date">
              <b-form-input id="featured-start-date" type="date" v-model="job.featured_start"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-4">
            <b-form-group label="Featured End" label-for="featured-end-date">
              <b-form-input id="featured-end-date" type="date" v-model="job.featured_end"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <hr>
        <div v-if="$store.getters.hasCapabilities('job_approval')"  class="text-center">
          <b-button variant="danger" v-on:click="(e) => {submit(e)}">Save</b-button>
        </div>
      </div>
    </div>
    <div v-if="!isLoaded" class="row card ">
      <div class="card-body text-center">
        <b-spinner variant="danger" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import JobBoardAPI from '../../api/jobBoard'
import OrganizationSelectorV2 from '../tools/OrganizationSelectorV2'
import Editor from '@tinymce/tinymce-vue'
import OccupationSearch from './OccupationSearch'

export default {
  name: 'job-post',
  components: {Editor, OccupationSearch, OrganizationSelectorV2},
  data: function () {
    return {
      job: null,
      isLoaded: false,
      errorMessage: null,
      jobPositions: ['Entry Level', 'Mid-Level', 'Executive/Senior Level'],
      employmentType: ['Full-Time', 'Part-Time', 'Contractor', 'Intern', 'Temporary', 'Seasonal'],
      industry: [
        '', 'Academic Institution', 'Biotechnology', 'Clinical/Quality/Regulatory/Reimbursement', 'Design/Development/Manufacturing',
        'Digital Health', 'Government', 'Health Plan/Insurers', 'Healthcare Provider', 'Investors', 'Legal/Tax/Accounting Services',
        'Marketing/Communications/Branding', 'Medical Device', 'Non-Profit', 'Pharmaceuticals', 'Professional Services',
        'R&D/Testing Services', 'Software Services & Support', 'Talent Recruitment & Retention', 'Unspecified/Other'
      ],
      approvalStatus: [
        { value: 0, text: 'Unapproved' },
        { value: 1, text: 'Approved' },
        { value: -1, text: 'Rejected' }
      ]
    }
  },
  computed: {
    tweetLink () {
      let companyName = this.job.twitter_screen_name !== null ? '.@' + this.job.twitter_screen_name : this.job.hiring_organization_name
      let text = companyName + ' is hiring a ' + this.job.job_title + '. Learn more at the Medical Alley Jobs Board: '
      let link = 'https://twitter.com/intent/tweet?url='
      link += encodeURIComponent('https://medicalalley.org/job-board/job-posting/?job_id=' + this.job.id + '&utm_campaign=jobs_board&utm_source=twitter&utm_medium=' + this.job.id)
      link += '&text=' + encodeURIComponent(text)
      return link
    },
    linkedinLink () {
      let text = this.job.hiring_organization_name + ' is hiring a ' + this.job.job_title + '. Learn more at the Medical Alley Jobs Board: '
      let link = 'https://www.linkedin.com/shareArticle?mini=true&url='
      link += encodeURIComponent('https://medicalalley.org/job-board/job-posting/?job_id=' + this.job.id + '&utm_campaign=jobs_board&utm_source=linkedin')
      link += '&title=' + encodeURIComponent(text)
      return link
    }
  },
  methods: {
    submit: function (e) {
      if (!this.validateSubmission()) {
        return
      }

      this.isLoaded = false
      this.errorMessage = null

      if (this.job.id === null) {
        JobBoardAPI.createJobPost(this.job).then(
          response => {
            this.isLoaded = true
            if (response.data.success) {
              this.job = response.data.data
              this.$router.push('/job-board/' + this.job.id)
            } else {
              this.errorMessage = response.data.message
            }
          }
        )
      } else {
        JobBoardAPI.updateJobPost(this.job.id, this.job).then(
          response => {
            if (response.data.success) {
              this.job = response.data.data
            } else {
              this.errorMessage = response.data.message
            }
            this.isLoaded = true
          }
        )
      }
    },
    selectedOrganization: function (e) {
      console.log(e)
      this.job.hiring_organization = e === null ? null : e.account_id
    },
    selectedOccupation: function (e) {
      this.job.occupation_category = e.id
    },
    validateSubmission: function (e) {
      this.errorMessage = null
      let required = ['submitter_name', 'submitter_email', 'date_posted', 'job_title', 'valid_through']
      for (let i = 0; i < required.length; i++) {
        if (this.job[required[i]] === null || this.job[required[i]] === '') {
          this.errorMessage = required[i] + ' is required'
          return false
        }
      }
      return true
    }
  },
  beforeMount () {
    if (this.$route.params.id === 'create') {
      this.job = {
        id: null,
        //  Submitter Information
        submitter_name: null,
        submitter_email: null,
        submitter_account_id: null,
        //  Required Job Information
        hiring_organization: null,
        job_title: null,
        job_description: null,
        employment_type: null,
        valid_through: new Date().toISOString().slice(0, 10),
        job_location_type: null,
        //  Optional Information
        industry: null,
        occupation_category: null,
        application_url: null,
        //  Location Information
        address_line_1: null,
        address_line_2: null,
        city: null,
        state: null,
        country: null,
        postal_code: null,
        //  Approval
        is_approved: 0,
        date_posted: new Date().toISOString().slice(0, 10)
      }
      this.isLoaded = true
      return
    }
    JobBoardAPI.getJobPost(this.$route.params.id)
      .then(
        response => {
          this.job = response.data
          this.isLoaded = true
        }
      )
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jobBoard/JobPost.vue